<script>
import axios from 'axios'

import ModalMixin from '@/mixins/ModalMixin.js'
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import CloseLockerPromptModal from '@/vcs/_shared/modals/CloseLockerPromptModal.vue'
import { eventBus } from '@/vcs/_shared/eventBus'

import {
  WindIcon,
  LogOutIcon,
  LogInIcon,
  XSquareIcon,
  HelpCircleIcon,
  XIcon
} from 'vue-feather-icons'

export default {
  extends: BaseModal,
  components: {
    WindIcon,
    LogOutIcon,
    LogInIcon,
    XSquareIcon,
    HelpCircleIcon,
    XIcon
  },
  mixins: [ModalMixin],
  data: function () {
    return {
      // NoAvailableBoxesModal,
      CloseLockerPromptModal
    }
  },
  mounted() {
    eventBus.$emit('refresh-token-via-websockets')
  },
  methods: {
    riseLockerIssue(message) {
      this.$blockUI()
      // if (this.$dev) {
      //   this.openBox();
      //   this.$unblockUI();
      //   return;
      // }

      // INFO: MUSI BYĆ DOKONANY /open_box, wtedy do DR przypisywane jest boxId, na $dev nie zadziała bo przechdzimy z DeliveryRequestUpdate do DeliveryConfirmation sztucznie
      let token = window.localStorage.getItem('delivery_request_token')
      axios({
        method: 'put',
        url: `/delivery_requests/${this.$route.params.id}/problem_with_box`,
        headers: {
          common: {
            Authorization: `Bearer ${token}`
          }
        },
        params: {
          message
        }
      })
        .then((response) => {
          console.log('riseLockerIssue response', response)
          this.$success(this.$t('success.boxIssueReported'))
          this.openBox()
        })
        .catch((error) => {
          this.$errorHumanized(error)
          this.$unblockUI()
        })
    },
    openBox() {
      this.$blockUI()
      // INFO: na podstawie deliveryRequestId wywoluje /open_box
      // :response - DR z box_id
      // :$dev - symulujemy zachowanie po tym jak dostaniemy
      let deliveryRequestId = this.$route.params.id

      if (this.$dev) {
        // this.openNoAvailableBoxesModal(); // no available boxes scenario
        this.close('1e41b1b4-fe90-4ffc-bc90-21bfebc511c9') // fires callback, updates boxId
        this.$unblockUI()
        return
      }

      let token = window.localStorage.getItem('delivery_request_token')
      axios({
        method: 'put',
        url: `/delivery_requests/${deliveryRequestId}/open_box`,
        params: { same_size: true },
        headers: {
          common: {
            Authorization: `Bearer ${token}`
          }
        }
      })
        .then((response) => {
          this.close(response.data.boxId) // fires callback, updates boxId
        })
        .catch((error) => {
          let errorCode = Object.values(
            (((error || {}).response || {}).data || {}).errors
          )
          if (errorCode == 'dr:9') {
            this.openCloseLockerPromptModal(this.$t('CLOSE_LOCKER_MESSAGE'), this.openBox)
          } else if (errorCode == 'dr:10') {
            this.openNoAvailableBoxesModal()
          } else {
            this.$errorHumanized(error)
          }
        })
        .finally(() => {
          this.$unblockUI()
        })
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="close(false)")
  .modal-body
    h1.page__header {{ $t('d.confirmation.raiseLockerIssueModal.header') }}
    h3.page__description.mb-5 {{ $t('d.confirmation.raiseLockerIssueModal.subheader') }}
    .row
      .col-12.col-lg-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.mb-5(
          v-ea-click="() => {riseLockerIssue('dirty_locker')}"
        )
          span {{ $t('d.confirmation.raiseLockerIssueModal.dirtyLockerButton') }}
          wind-icon(size="1.5x")
      .col-12.col-lg-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.mb-5(
          v-ea-click="() => {riseLockerIssue('cant_open')}"
        )
          span {{ $t('d.confirmation.raiseLockerIssueModal.cantOpenButton') }}
          log-out-icon(size="1.5x")
      .col-12.col-lg-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.mb-5(
          v-ea-click="() => {riseLockerIssue('cant_close')}"
        )
          span {{ $t('d.confirmation.raiseLockerIssueModal.cantCloseButton') }}
          log-in-icon(size="1.5x")
      .col-12.col-lg-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.mb-5(
          v-ea-click="() => {riseLockerIssue('locker_too_small')}"
        )
          span {{ $t('d.confirmation.raiseLockerIssueModal.lockerTooSmallButton') }}
          x-square-icon(size="1.5x")
      .col-12.col-lg-4
        button.btn.btn-outline-dark.btn-block.d-flex.justify-content-between.mb-5(
          v-ea-click="() => {riseLockerIssue('other')}"
        )
          span {{ $t('d.confirmation.raiseLockerIssueModal.otherButton') }}
          help-circle-icon(size="1.5x")
</template>
